import { render, staticRenderFns } from "./RelativeProduct.component.vue?vue&type=template&id=fe77333a"
import script from "./RelativeProduct.component.vue?vue&type=script&lang=js"
export * from "./RelativeProduct.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports